import { TypeInitProps, TypeRequest } from '../../types';
import { sliderView } from '../../utils/slider';
import { set, get } from '../../utils/data';
import createXHR from '../../request/xhr';
import createFetch from '../../request/fetch';
import { verificationView } from '../../utils/web-verification';

export default abstract class BaseInterface {
  request: TypeRequest;
  constructor(props: TypeInitProps, type: string) {
    const { printLog = false } = props;
    // if (printLog) {
    console.log(
      '%cAccountApi Version >>>>%O',
      'background: #222; color: #bada55',
      __VERSION__
    );
    // }

    set('initProps', props);
    // init request
    this.request = new RequestBehavior(props, type) as TypeRequest;

    sliderView.init({ ...props, request: this.request });
    // web verification
    verificationView.init({ ...props, request: this.request });
  }
}

// init Params
const initParams = (props: TypeInitProps, type: string) => {
  const {
    scene = 'normal',
    aid,
    language = '',
    subjectAid = 0,
    aff_multi_login = 0,
    generalParams = {},
  } = props;
  let params;
  // Handling common parameters in fetch -- web
  if (type === 'web') {
    const commonParams: {
      // appid
      aid: number;
      // aff need
      subject_aid?: number;
      aff_multi_login?: number;
    } = {
      aid,
    };
    if (scene === 'aff') {
      commonParams.subject_aid = subjectAid;
    }
    if (aff_multi_login === 1) {
      commonParams.aff_multi_login = 1;
    }
    params = commonParams;
  }

  if (type === 'sso' || type === 'auth') {
    const commonParams: {
      aid: number;
      aff_multi_login?: number;
    } = {
      aid,
    };
    if (aff_multi_login === 1) {
      commonParams.aff_multi_login = 1;
    }
    params = commonParams;
  }

  params = {
    ...params,
    account_sdk_source: type,
    sdk_version: __VERSION__,
  };

  if (generalParams) {
    try {
      params = {
        ...generalParams,
        ...params,
      };
    } catch (error) {
      console.error('[error], generalParams is not object!');
    }
  }
  // language
  if (language) {
    params = { ...params, language };
  }
  return params;
};

//  class request
class RequestBehavior {
  constructor(props: TypeInitProps, type = 'web') {
    if (get('initProps')?.fetch) {
      return createFetch();
    } else {
      return createXHR(initParams(props, type), props.xhrConfig);
    }
  }
}
